<div class="team-header">
  <h3 class="team-title">Members</h3>
  <div class="main-button" (click)="openInviteModal()">
    <inline-svg src="Plus.svg" className="invite-icon" color="#fff"></inline-svg>
    <span>Invite New User</span>
  </div>
</div>
<div class="pseudo-table">
  <div class="header">
    <div class="column-user">User</div>
    <div class="column-name">Full Name</div>
    <div class="column-role">Role</div>
    <div class="column-action"></div>
  </div>
  <div class="horizontal-separator"></div>
  <div class="body">
    @for (user of teamData; track user) {
      <div class="row" [ngClass]="{'pending': !user.is_accepted }">
        <div class="column-user">
          <frmg-user-logo [user]="user" [empty]="!user.is_accepted"></frmg-user-logo>
          <span>{{ user.email }}</span>
        </div>
        <div class="column-name">
          <span>{{ user.display_name }}</span>
        </div>
        <div class="column-role">
          @if (user.role !== 'admin' && user.email !== currentUser.email && currentUser && currentUserRole !== 'member' && user.is_accepted) {
            <mat-select [(ngModel)]="user.role" class="role-select" panelClass="role-panel"
              >
              @for (role of availableMembership; track role) {
                <mat-option [value]="role"
                  (click)="setMembership()"
                  style="text-transform: capitalize">{{ role === 'member' ? 'member' : 'admin' }}
                </mat-option>
              }
            </mat-select>
          }
          @if (user.email == currentUser.email || user.role === 'admin' || !user.is_accepted) {
            {{ user.role === 'member' ? 'member' : 'admin' }}
          }
        </div>
        <div class="column-action">
          @if (user.email !== currentUser.email &&  currentUserRole !== 'member' && user.is_accepted) {
            <inline-svg src="remove.svg" class="remove-btn"
              (click)="removeMember()"
              color="#7F8F98"
              hoverColor="#7F8F98"
            ></inline-svg>
          }
          @if (!user.is_accepted) {
            <span class="remove-btn" (click)="revokeUser()">Revoke</span>
          }
        </div>
      </div>
    }
  </div>
  <div class="horizontal-separator"></div>
</div>

